export default class Errors {

    // activation-dux errors
    static ERROR_ACTIVATION_ACTIVATE = 'ERROR_ACTIVATION_ACTIVATE';

    // client-dux errors
    static ERROR_CLIENT_FETCHCLIENTDATA = 'ERROR_CLIENT_FETCHCLIENTDATA';
    static ERROR_CLIENT_FETCH_BUNDLE_DATA = 'ERROR_CLIENT_FETCH_BUNDLE_DATA';

    // forgot-password-dux errors
    static ERROR_FORGOTPASSWORD_REQUESTPASSWORD = 'ERROR_FORGOTPASSWORD_REQUESTPASSWORD';

    // forgot-user-id-dux errors
    static ERROR_FORGOTUSERID_REQUESTUSERNAME = 'ERROR_FORGOTUSERID_REQUESTUSERNAME';

    // rules-dux errors
    static ERROR_EXPORT_RULES_FAILED = 'ERROR_EXPORT_RULES_FAILED';

    // contact-us-dux errors
    static ERROR_CONTACTUS_SUBMISSION_FAILED = 'ERROR_CONTACTUS_SUBMISSION_FAILED';

    // reset-password-dux errors
    static ERROR_RESETPASSWORD_SETPASSWORD = 'ERROR_RESETPASSWORD_SETPASSWORD';

    // login-dux errors
    static ERROR_LOGIN = 'ERROR_LOGIN';

    // profile-dux errors
    static ERROR_PROFILE_CHANGEPASSWORD = 'ERROR_PROFILE_CHANGEPASSWORD';
    static ERROR_PROFILE_SETUSERLOCALE = 'ERROR_PROFILE_SETUSERLOCALE';

    // user-dux errors
    static ERROR_USER_VALIDATESESSION = 'ERROR_USER_VALIDATESESSION';

    // shop-dux errors
    static ERROR_SHOP_FETCH_CATALOG_URL = 'ERROR_SHOP_FETCH_CATALOG_URL';

    // on-the-spot-dux
    static ERROR_OTS_REDEEM = 'ERROR_OTS_REDEEM';

    // sso-authenticated errors
    static ERROR_SSO_AUTHENTICATED_NO_SESSIONID = 'ERROR_SSO_AUTHENTICATED_NO_SESSIONID';
    static ERROR_SSO_AUTHENTICATED_FETCH_PROFILE = 'ERROR_SSO_AUTHENTICATED_FETCH_PROFILE';
    static ERROR_SSO_AUTHENTICATED = 'ERROR_SSO_AUTHENTICATED';
    static ERROR_SSO_AUTHENTICATED_INVALID_CREDENTIALS = 'ERROR_SSO_AUTHENTICATED_INVALID_CREDENTIALS';

    static getByType ( state, errorType ) {
        return state.errorData.errorList
            .filter( error => error.errorType === errorType )
            .map( error => {
                error.state = state;
                return error;
            } );
    }

}
